import { styled } from 'styled-components';

import CheckSVG from '../assets/check-icon.svg?react';

export const StyledCheckIcon = styled(CheckSVG)`
  width: 18px;
  height: 13px;
  flex-shrink: 0;
`;
